<template>
  <section>
    <div class="row" v-if="isShowLinkActions">
      <div class="col-md-12">
        <p>
          The following is your organization's marketing website which you can
          use in your marketing materials (such as email blasts).
        </p>
      </div>
    </div>
    <div class="row" v-if="isShowLinkActions">
      <div class="col-md-12">
        <a :href="marketingLink" target="_blank">{{ marketingLink }}</a>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <p>
          The following is your organization's getting started link. You can
          send this to users who are ready to get started. The link will guide
          them through installing the app onto their mobile device.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <a :href="startLink" target="_blank">{{ startLink }}</a>
      </div>
    </div>
    <div class="row mt-3" v-if="isShowLinkActions">
      <div class="col-md-3">
        <button
          class="btn btn-primary btn-sm"
          @click="generateLink"
          :disabled="isGenerating"
        >
          <i v-if="isGenerating" class="fas fa-spinner fa-spin"></i>
          <span class="ms-2">Generate a New Link</span>
        </button>
      </div>
      <div class="col-md-9"></div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'organization-links',
  data() {
    return {
      isGenerating: false,
    }
  },
  mounted() {
    this.isGenerating = false
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    ...mapGetters('users', ['isFeatureAllowed']),
    id() {
      let _data = null
      if (this.organization) {
        _data = this.organization.id
      }
      return _data
    },
    isShowLinkActions() {
      let _data = false
      if (this.isFeatureAllowed('organization_links')) {
        _data = true
      }
      return _data
    },
    marketingLink() {
      let _data = null
      if (this.organization) {
        _data = this.organization.weburl
      }
      return _data
    },
    startLink() {
      let _data = null
      if (this.organization) {
        _data = this.organization.deeplinkShort
      }
      return _data
    },
  },
  methods: {
    ...mapActions('organizations', [
      'setOrganizationData',
      'generateNewDeepLink',
    ]),
    async generateLink() {
      this.isGenerating = true
      await this.generateNewDeepLink(this.organization.id)
      this.isGenerating = false
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
